import {defineStore} from 'pinia';
import {type Ref, ref} from 'vue';
import {useStorage} from '@vueuse/core';
import {type Order} from 'dummen-shared';

export const useCreateOrderStore = defineStore('createOrderStore', () => {

	const PRE_SELECTED_ORDER_ID_KEY = 'preSelectedAddToExistingOrderId';

	const poIdToCreate: Ref<string | null> = ref(null);
	const poName: Ref<string> = ref('');
	const poNote: Ref<string> = ref('');
	const preferredDeliveryDay: Ref<number | null> = ref(null);
	const selectedDeliveryAddressId: Ref<string> = ref('');
	const updateAvailability: Ref<boolean> = ref(true);
	const selectedExistingPurchaseOrder: Ref<Order | null> = ref(null);
	const preSelectedOrderId = useStorage(PRE_SELECTED_ORDER_ID_KEY, undefined);

	const setPoName = (name: string) => poName.value = name ? name.toUpperCase() : '';

	const setPoNote = (notes: string) => poNote.value = notes ?? '';

	const setPreferredDeliveryDay = (deliveryDay: number) => preferredDeliveryDay.value = deliveryDay;

	const setSelectedDeliveryAddressId = (deliveryAddressId: string) => selectedDeliveryAddressId.value = deliveryAddressId;

	const setSelectedExistingPurchaseOrder = (order: Order | null) => selectedExistingPurchaseOrder.value = order;

	const reset = () => {
		poName.value = '';
		poNote.value = '';
		preferredDeliveryDay.value = null;
		selectedDeliveryAddressId.value = '';
		selectedExistingPurchaseOrder.value = null;
		preSelectedOrderId.value = undefined;
	}

	return {
		poName,
		poNote,
		poIdToCreate,
		preferredDeliveryDay,
		selectedDeliveryAddressId,
		updateAvailability,
		selectedExistingPurchaseOrder,
		preSelectedOrderId,
		setPoName,
		setPoNote,
		setPreferredDeliveryDay,
		setSelectedDeliveryAddressId,
		setSelectedExistingPurchaseOrder,
		reset
	};
});
